import { CssBaseline, ThemeProvider } from '@mui/material';
import { useRoutes } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeSettings } from './theme/Theme';
import RTL from './layouts/full/shared/customizer/RTL';
import ScrollToTop from './components/shared/ScrollToTop';
import Router from './routes/Router';
import { useEffect } from 'react';
import axios from 'axios';
import { api } from './Helper/Data';
import { getCookie } from './Helper/Cokkies';
import { getLocalStorage } from './Helper/LocalStorage';
import { getCurrentLoged } from './store/redux/CompanyUser';

function App() {
  const routing = useRoutes(Router);
  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.customizer);
  const disPatch = useDispatch();
  let token = getCookie("token");
  let user = getLocalStorage("user")

  useEffect(() => {
    if(token){
      axios
        .post(api.url + "/get-loged-user", { id: user.id }, { headers: { Authorization: "Bearer " + token } })
        .then(function (response) {
          console.log(response.data)
          disPatch(getCurrentLoged(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, [disPatch])

  return (
    <ThemeProvider theme={theme}>
      <RTL direction={customizer.activeDir}>
        <CssBaseline />
        <ScrollToTop>{routing}</ScrollToTop>
      </RTL>
    </ThemeProvider>
  );
}

export default App;
